import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { usePaymentNotification } from '../contexts/PaymentNotificationContext';

const PaymentNotificationBanner: React.FC = () => {
  const { notification } = usePaymentNotification();

  if (!notification.active || !notification.message) {
    return null;
  }

  // Formatar data de vencimento se disponível
  const formatExpirationDate = (dateString?: string) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
    } catch {
      return dateString;
    }
  };

  const expirationDate = formatExpirationDate(notification.plan_expiration_date);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1400, // Acima do AppBar (z-index padrão é 1100)
        width: '100%',
        maxWidth: '100%',
      }}
    >
      <Alert
        severity="error"
        icon={<WarningIcon />}
        sx={{
          borderRadius: 0,
          py: 0.5,
          px: 2,
          fontSize: '0.75rem',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '32px',
          '& .MuiAlert-message': {
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            fontSize: '0.75rem',
            fontWeight: 500,
          },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontSize: '0.75rem',
            fontWeight: 500,
            color: 'inherit',
            display: 'flex',
            alignItems: 'center',
            gap: 0.5,
            flexWrap: 'wrap',
            justifyContent: 'center',
          }}
        >
          {notification.message}
          {expirationDate && (
            <Box component="span" sx={{ fontWeight: 600, ml: 0.5 }}>
              ({expirationDate})
            </Box>
          )}
        </Typography>
      </Alert>
    </Box>
  );
};

export default PaymentNotificationBanner;

